<template>
	<div class="copyright center-width">
		<p>- <span>上海商晟通云网络科技有限公司 </span> -</p>
	</div>
</template>

<script>
	export default {
		data() {
		  return {
      };
		},
		methods: {
		},
		components:{
		}
	}
</script>

<style lang="stylus" scoped>
.copyright {
	width: 100%;
	min-width: 1220px;
	text-align: center;
	padding: 24px 0;
	text-align: center;
	font-size: 12px;
	line-height: 28px;
	color: #909090;
	background-color: #333333;
	border-top: 1px solid #424242;
}
</style>



// WEBPACK FOOTER //
// copyright.vue?40121838